<section class="order-history-section">
  <div class="container">
    <!-- Header -->
    <div class="section-header">
      <h1 class="section-title">{{ "page.order.ordersHistory.title" | translate }}</h1>
      <p class="section-subtitle">{{ "page.order.ordersHistory.description" | translate }}</p>
    </div>

    <!-- Loading -->
    <div *ngIf="ordersDataSource.loading$ | async" class="orders-list" aria-hidden="true">
      <div class="order-card skeleton-card" *ngFor="let i of skeletonRows">
        <div class="skeleton-line skeleton-line--label"></div>
        <div class="skeleton-line skeleton-line--value"></div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="(ordersDataSource.loading$ | async) === false && ordersDataSource.getData().length === 0">
      <div class="empty-state-icon">
        <mat-icon>receipt_long</mat-icon>
      </div>
      <h2>{{ "page.order.ordersHistory.empty" | translate }}</h2>
    </div>

    <!-- Orders -->
    <div class="orders-list" *ngIf="(ordersDataSource.loading$ | async) === false && ordersDataSource.getData().length > 0">
      <div class="order-card" *ngFor="let orderHistory of ordersDataSource.getData()">
        <!-- Header -->
        <div
          class="order-header"
          role="button"
          tabindex="0"
          [attr.aria-expanded]="!orderHistory.collapsed"
          (click)="toggleOrder(orderHistory)"
          (keydown.enter)="toggleOrder(orderHistory)"
          (keydown.space)="toggleOrder(orderHistory); $event.preventDefault()"
        >
          <div class="order-primary">
            <div class="order-date" *ngIf="orderHistory.order.date">
              {{ orderHistory.order.date | localizedDate: "dd MMMM yyyy" }}
            </div>

            <span
              class="status-badge"
              [class.pending]="orderHistory.order.status === OrderStatus.PENDING_CHECKOUT"
              [class.failed]="orderHistory.order.status === OrderStatus.PAYMENT_FAILED"
              [class.paid]="orderHistory.order.status === OrderStatus.PAID"
            >
              {{ orderHistory.order.status | orderStatus | translate }}
            </span>
          </div>

          <div class="order-side">
            <div class="order-total">
              <span class="order-total-label">{{ "page.order.ordersHistory.total" | translate }}</span>
              <span class="order-total-value">
                {{ orderHistory.totalPrice.value | minorUnitCurrency: orderHistory.totalPrice.currency }}
              </span>
            </div>

            <button
              class="expand-button"
              [class.expanded]="!orderHistory.collapsed"
              (click)="toggleOrder(orderHistory); $event.stopPropagation()"
              [attr.aria-label]="orderHistory.collapsed ? 'expand' : 'collapse'"
            >
              <mat-icon>expand_more</mat-icon>
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="order-content" *ngIf="!orderHistory.collapsed">
          <div class="order-items">
            <div class="order-line" *ngFor="let item of orderHistory.items">
              <div class="item-info">
                <span class="item-name">{{ item.name }}</span>
                <span class="item-address" *ngIf="item.shippingAddress">
                  <mat-icon class="item-address-icon">place</mat-icon>
                  {{ item.shippingAddress }}
                </span>
              </div>

              <div class="payment-info">
                <div class="price-container">
                  <span class="price">
                    {{ item.pricePerUnit.value | minorUnitCurrency: item.pricePerUnit.currency }}
                  </span>
                  <span *ngIf="item.pricePerUnit.timing" class="subscription">
                    {{
                      "page.order.timing." + item.pricePerUnit.timing.periodUnit
                        | pluralTranslate: item.pricePerUnit.timing.period
                        | lowercase
                    }}
                  </span>
                </div>
                <div
                  *ngIf="
                    item.paymentStatus === ServiceRequestPaymentStatus.PENDING ||
                    item.paymentStatus === ServiceRequestPaymentStatus.NOT_PAID ||
                    item.paymentStatus === ServiceRequestPaymentStatus.PAST_DUE ||
                    item.paymentStatus === ServiceRequestPaymentStatus.EXPIRED ||
                    item.paymentStatus === ServiceRequestPaymentStatus.CANCELED
                  "
                  class="subscription-status"
                  [style.color]="item.paymentStatus | srPaymentStatusColor"
                >
                  <mat-icon>{{ item.paymentStatus | srPaymentStatusIcon }}</mat-icon>
                  <span>
                    {{ item.paymentStatus | srPaymentStatus | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="order-billing" *ngIf="orderHistory.order.billingAddress">
            <span class="order-billing-label">{{ "page.order.ordersHistory.billingAddress" | translate }}</span>
            <span class="order-billing-value">{{ orderHistory.order.billingAddress }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      [hidden]="(ordersDataSource.loading$ | async) || ordersDataSource.getData().length === 0"
      (page)="onPage($event)"
      [length]="totalCount"
      [pageSize]="ordersFilters.pageSize ?? 10"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="(ordersFilters.page ?? 1) - 1"
      [showFirstLastButtons]="true"
      class="orders-paginator"
      aria-label="Select page"
    ></mat-paginator>
  </div>
</section>
